
import React, { useRef, useEffect } from "react";
import ReactECharts from "echarts-for-react";




const EChart = ({ options = {}, style = {}, height, width }) => {
	const chartRef = useRef(null);

	// Resize chart on mount and window resize
	useEffect(() => {
		const chartDiv = chartRef.current?.getEchartsInstance?.()?.getDom?.() || chartRef.current?.getEchartsInstance?.()?.dom;
		const parent = chartDiv?.parentElement;
		let resizeObserver;
		let resizeTimeout;
		const handleResize = () => {
			if (resizeTimeout) clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				if (chartRef.current && chartRef.current.getEchartsInstance) {
					chartRef.current.getEchartsInstance().resize();
				}
			}, 150); // 150ms debounce to prevent infinite loops
		};
		// Initial resize after mount
		const initialTimeout = setTimeout(handleResize, 200);
		// Observe parent size changes
		if (parent && window.ResizeObserver) {
			resizeObserver = new window.ResizeObserver(handleResize);
			resizeObserver.observe(parent);
		}
		// Fallback to window resize
		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
			if (resizeObserver && parent) resizeObserver.unobserve(parent);
			if (resizeTimeout) clearTimeout(resizeTimeout);
			if (initialTimeout) clearTimeout(initialTimeout);
		};
	}, []);

		const mergedStyle = {
			width: width || "100%",
			height: height || "100%",
			borderRadius: 4,
			fontWeight: 400,
			fontSize: 16,
			color: "rgb(60,60,60)",
			...style,
		};
		return (
			<div style={mergedStyle}>
				<ReactECharts
					ref={chartRef}
					option={options}
					style={{ width: "100%", height: "100%", borderRadius: 4, fontWeight: 400, fontSize: 16, color: "rgb(60,60,60)" }}
					notMerge={false}
					lazyUpdate={false}
					opts={{ renderer: 'canvas' }}
				/>
			</div>
		);
};

export default EChart;